import { FC } from 'react';
import Layout from '@/components/layout/Layout';
import Pagination from '@/components/ui/pagination/Pagination';
import AlphabetSearch from '@/components/ui/alphabet-search/AlphabetSearch';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import ListItem from '@/components/ui/listItem/ListItem';
import SectionTitle from '@/components/ui/section-title/SectionTitle';
import { SERIES_FOR_PAGE } from '@/helpers/variables';
import { ISeries, ISeriesData } from '@/interfaces/series.interface';
import { IWidgetsSideBar } from '@/interfaces/widgets.interface';
import { getCurrentPageName } from '@/helpers/helpers';

interface ISeriesProps extends IWidgetsSideBar {
  letterSign?: string;
  series: ISeries;
}

const Series: FC<ISeriesProps> = ({ series, letterSign, todayWidget, popularBooksWidget }) => {
  const pagesCount = Math.ceil(series?.total_count / SERIES_FOR_PAGE);

  const currentPath = String(useGetUrlPath());
  const isSearchLetterPage = currentPath.includes('letter');
  const currentPathSplit = currentPath.split('/');

  const getSearchLetterWord = () => {
    if (currentPath.includes('page=')) {
      return currentPathSplit[currentPathSplit.length - 2];
    }
    return currentPathSplit[currentPathSplit.length - 1];
  };

  //Seo block
  const SEO_TITLE = `Серии книг - скачать книги бесплатно${getCurrentPageName(series.page)}`;
  const SEO_DESCRIPTION = 'Серии книг - скачать книги бесплатно';
  const SEO_CANONICAL = '/serii-knig';

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} pageHref={useGetUrlPath()} breadcrumbs={<Breadcrumbs firstPageName="Серии книг" />} todayWidget={todayWidget} popularBooksWidget={popularBooksWidget}>
      <SectionTitle name="Cерии книг" />
      <AlphabetSearch url={'/serii-knig/letter/'} letterSign={String(letterSign)} title="Cерии по алфавиту" />

      {!!series.data.length ? (
        <>
          <ul className="itemsList">
            {series.data.map((item: ISeriesData) => (
              <ListItem key={item.id} itemAlias={String(item.title_translit)} title={item.title} count={item.book_count} alias="seria-knig" />
            ))}
          </ul>
        </>
      ) : (
        <div>{`Cерии не найдены`}</div>
      )}

      <Pagination pagesCount={pagesCount ?? 0} postName={!!isSearchLetterPage ? `serii-knig/letter/${getSearchLetterWord()}/page=` : `serii-knig/page=`} />
    </Layout>
  );
};

export default Series;
